module.exports = __webpack_public_path__ + "img/freeze.f6557484.png";